/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const compose_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.75 14.251v7.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h7.5m11.78.401 1.061-1.061a2.25 2.25 0 1 0-3.182-3.182L18.348 2.47m3.182 3.182-8.485 8.485-3.712.531.53-3.713 8.485-8.485m3.182 3.182L18.348 2.47"
    />
  </svg>
)
export default compose_medium
